var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeSelectedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2592 2.96661C13.9424 2.5142 13.3189 2.40426 12.8665 2.72103L3.59882 9.21031C3.38156 9.36243 3.23364 9.59463 3.18759 9.85581L1.69668 18.3112C1.60078 18.8551 1.96394 19.3737 2.50784 19.4696L7.43188 20.3379C7.97577 20.4338 8.49443 20.0706 8.59033 19.5267L9.28493 15.5875C9.47673 14.4997 10.5141 13.7733 11.6018 13.9651C12.6896 14.157 13.416 15.1943 13.2242 16.2821L12.5296 20.2213C12.4337 20.7652 12.7968 21.2838 13.3407 21.3797L18.2648 22.248C18.8087 22.3439 19.3273 21.9807 19.4232 21.4368L20.9141 12.9815C20.9602 12.7203 20.9006 12.4515 20.7485 12.2343L14.2592 2.96661Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeSelectedIcon);
export default __webpack_public_path__ + "static/media/HomeSelectedIcon.08e12e80a2342066af645d94e781479a.svg";
export { ForwardRef as ReactComponent };